var util = require('./util'),
    parse = require('../../../path/parse'),
    render = require('../../../path/render');

function path(g, o) {
  if (o.path == null) return true;
  var p = o.pathCache || (o.pathCache = parse(o.path));
  render(g, p, o.x, o.y);
}

module.exports = {
  draw: util.drawAll(path),
  pick: util.pickPath(path)
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-scenegraph/src/render/canvas/marks/path.js
// module id = 1536
// module chunks = 0